export { PLUGIN_KEY, PLUGIN_PRIORITY, PersistentState } from "./persistentState.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/persistentState/index.mjs
// module id = 1540
// module chunks = 1